import Page from "webPage/Page";
import CanvasImage from "../CanvasImage";
import Ajax from "base/Ajax";
import AjaxForm, {EVENT_ERROR, EVENT_SUCCESS} from "webPage/AjaxForm";
import {svg_include} from "base/functions";

Page.register('/training', function () {

    $("body").on("click", ".js-training-enquire", function () {
        $("body").addClass("modal-active");
        let $course = $(this).parents('.training-course');
        let title = $course.find("h4").text();
        let id = $course.attr("data-id");

        $(".js-training-enquire-modal").addClass("modal--active")
            .find(".modal__header h4").text(title).end()
            .find(".modal__form-text p").text('Fill out the form below to get more information about this course and to find out about available dates.').end()
            .find("[name=course]").val(id).end()
            .find("[name=type]").val('course').end()
            .find(".modal__form-text, .form").show().end()
            .find(".form__success").html(
            eotwJSXFactory('div', null, [
                eotwJSXFactory('span', {className: "title-icon title-icon--purple"}).html(svg_include('equip-logo-small')),
                eotwJSXFactory('h3', null, ["Thank you"]),
                eotwJSXFactory('h4', null, ["Thanks for applying"]),
                eotwJSXFactory('p', null, ["We’ll be in touch to talk about availability and next steps for booking your training course."])
            ])
        ).end()
            .find(".form__success").hide();

        form.validator.updateInputs();
        return false;
    }).on("click", ".js-training-general", function () {
        $("body").addClass("modal-active");

        $(".js-training-enquire-modal").addClass("modal--active")
            .find(".modal__header h4").text('General Enquiry').end()
            .find(".modal__form-text p").text('Fill out the form below to get more information about our training courses.').end()
            .find("[name=course]").val('').end()
            .find("[name=type]").val('general').end()
            .find(".modal__form-text, .form").show().end()
            .find(".form__success").html(
            eotwJSXFactory('div', null, [
                eotwJSXFactory('span', {class: "title-icon title-icon--purple"}).html(svg_include('equip-logo-small')),
                eotwJSXFactory('h3', null, ["Thank you"]),
                eotwJSXFactory('h4', null, ["Thanks for getting in touch"]),
                eotwJSXFactory('p', null, ["We’ll be in touch to talk about our training courses."])
            ])
        ).end()
            .find(".form__success").hide();

        form.validator.updateInputs();
        return false;
    });

    let form = new AjaxForm($(".js-training-enquire-form"), ($form, formData) => {
        return Ajax.post("equip", "training", formData, Ajax.WEBSITE);
    }, {
        validatorSettings: {
            inputOptions: {operator: "your"},
            inputs: {
                "g-recaptcha-response": {
                    messages: {
                        empty: "Please complete the recaptcha",
                    },
                },
            },
        },
    });

    form.on(EVENT_ERROR, () => {
        grecaptcha.reset();
    });

    form.on(EVENT_SUCCESS, () => {
        $(".js-training-enquire-modal").find(".form__success").show();
        $(".js-training-enquire-modal").find(".modal__form-text, .form").hide();
        grecaptcha.reset();
    });

    window.onRecaptchaLoad = function () {
        form.validator.updateInputs();
    };


    let masksContent = {
        0: [
            {
                'url': '/images/png/masks/content/content-mask--mobile.png',
                'vPos': 'top'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/content/content-mask--600.png',
                'vPos': 'top'
            }
        ],
        960: [
            {
                'url': '/images/png/masks/content/content-mask.png',
                'vPos': 'top'
            }
        ]
    };

    let masksContent2 = {
        0: [
            {
                'url': '/images/png/masks/content/content-mask--mobile.png',
                'vPos': 'top'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/content/content-mask-2--600.png',
                'vPos': 'top'
            }
        ],
        960: [
            {
                'url': '/images/png/masks/content/content-mask-2.png',
                'vPos': 'top'
            }
        ]
    };

    let masksTrainingCourses = {
        0: [
            {
                'url': '/images/png/masks/training/training-courses-mask-top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/training/training-courses-mask-bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/training/training-courses-mask-top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/training/training-courses-mask-bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        960: [
            {
                'url': '/images/png/masks/training/training-courses-mask-top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/training/training-courses-mask-bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        1400: [
            {
                'url': '/images/png/masks/training/training-courses-mask-top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/training/training-courses-mask-bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ]
    };

    new CanvasImage($(".content__img--first"), masksContent);
    new CanvasImage($(".content__img--second"), masksContent2);
    new CanvasImage($(".tc__bg"), masksTrainingCourses);
});
